import { render } from "./SharedDataKeyForm.vue?vue&type=template&id=2caf5f77"
import script from "./SharedDataKeyForm.vue?vue&type=script&lang=js"
export * from "./SharedDataKeyForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__